import repository from './repsitory'

const resource = '/parameters'

export default {

    getStatusesTarget () {
        return repository.get(`${resource}/statusesTarget`)
    },
    getStatusesDevice () {
        return repository.get(`${resource}/statusesDevice`)
    },
    getStatusesPerson () {
        return repository.get(`${resource}/statusesPerson`)
    },
}
